import React from "react";
import LoadingSpinnerAnimation from "web/react/components/lottie-animations/loading-spinner-animation/loading-spinner-animation";

function LoadingSpinnerCircle(): JSX.Element {
    return <LoadingSpinnerAnimation />;
}

export default LoadingSpinnerCircle;
